import enUS from './en-US'
import heIL from './he-IL'
import ukUA from './uk-UA'

export default { 
	'en-US': enUS, // English
	'he-IL': heIL, // Hebrew
	'uk-UA': ukUA, // Ukrainian
}